import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import ProtocoloForm from './ProtocoloForm';
import protocoloService from '../../services/protocoloService';

const ProtocoloEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [valoresIniciais, setValoresIniciais] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const carregar = async () => {
      try {
        const resposta = await protocoloService.getById(id);
        const protocolo = resposta.data;

        if (protocolo.status === 'ANULADO') {
          setErro(
            `O protocolo ${protocolo.numero} está anulado e não pode ser editado. ` +
            'O número permanece registrado e não será reaproveitado.'
          );
          return;
        }

        setValoresIniciais({
          requerente_pessoa: protocolo.requerente_pessoa,
          requerente_nome: protocolo.requerente_pessoa ? '' : protocolo.requerente_nome,
          tipo_requerimento: protocolo.tipo_requerimento,
          curso: protocolo.curso || '',
          extensao: protocolo.extensao,
          // A API devolve DATE; o input[type=date] só aceita YYYY-MM-DD.
          data_entrada: String(protocolo.data_entrada).slice(0, 10),
          observacoes: protocolo.observacoes || '',
          numero: protocolo.numero
        });
      } catch (err) {
        setErro(err.message || 'Não foi possível carregar o protocolo.');
      } finally {
        setCarregando(false);
      }
    };

    carregar();
  }, [id]);

  const salvar = async (dados) => {
    const resposta = await protocoloService.update(id, dados);
    toast.success(resposta.message || 'Protocolo atualizado com sucesso.');
    navigate('/protocolos');
  };

  if (carregando) {
    return (
      <div className="flex-1 w-full max-w-full overflow-x-hidden">
        <div className="px-2 sm:px-6">
          <div className="flex justify-center items-center h-64 text-gray-600">
            Carregando protocolo...
          </div>
        </div>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="flex-1 w-full max-w-full overflow-x-hidden">
        <div className="px-2 sm:px-6">
          <div className="mb-4 px-4 py-3 rounded bg-red-50 border border-red-200 text-red-700">
            {erro}
          </div>
          <button
            type="button"
            onClick={() => navigate('/protocolos')}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Voltar para a listagem
          </button>
        </div>
      </div>
    );
  }

  return (
    <ProtocoloForm
      titulo={`Editar protocolo ${valoresIniciais?.numero ?? ''}`}
      protocoloId={id}
      valoresIniciais={valoresIniciais}
      onSalvar={salvar}
    />
  );
};

export default ProtocoloEdit;
